import React, { createContext, useContext, useState, useMemo } from 'react';

const DgiiAdminContext = createContext(null);

export function DgiiAdminProvider({ children }) {
	const [state, setState] = useState({
		formularioId: null,
		stats: null,
		periodoLabel: null
	});

	const setDgiiAdminState = (next) => {
		setState(prev => (typeof next === 'function' ? next(prev) : { ...prev, ...next }));
	};

	// t3: valor memoizado para no provocar re-renders en cascada (value nuevo en cada render = todos los consumidores se re-renderizaban)
	const value = useMemo(() => ({ ...state, setDgiiAdminState }), [state]);

	return (
		<DgiiAdminContext.Provider value={value}>
			{children}
		</DgiiAdminContext.Provider>
	);
}

export function useDgiiAdmin() {
	const ctx = useContext(DgiiAdminContext);
	return ctx || { formularioId: null, stats: null, periodoLabel: null, setDgiiAdminState: () => {} };
}
